<template>
  <div>
    <div
      class="modal fade"
      id="ModalAggDetalleSolicitud"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalDetalle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="width: 100%; max-width: 100%">
          <div class="modal-header">
            <button type="button" class="close" @click="cerrarModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-----------------MOSTRAR REQUERIMIENTOS DE TRASLADOS--------------->
          <div class="element-box mb-0 px-6 py-1"> 
            <h6 class="text-center text-success mb-0">Requerimientos de tienda:</h6>                
              <div class="d-flex justify-content-center">
                <div class="border border-3 border-success  rounded" style="width:250px">
                  <h6 class="text-center my-1 text-success">{{ tienda_destino.nombre }}</h6>
                </div>
              </div> 
                  <!-----------------FILTROS------------------->
                  <div class="col-sm-12 d-flex justify-content-center mt-3">                    
                    <form class="form-inline " @submit="filterDataSubmit">
                      <input
                        class="form-control form-control-sm rounded bright mx-2"
                        placeholder="# Requerimiento"
                        v-model="filterTabla.numero_requerimiento"
                        type="text"
                        style="width: 200px"
                      />                    
                      <!--select
                        class="form-control rounded bright"
                        autofocus="autofocus"
                        v-model="filterTabla.tienda_destino"  
                        style="width: 25%"
                        placeholder="Tienda"
                      >
                        <option disabled value="">Tienda</option>
                        <option
                          v-for="(op, key) in tiendas"
                          :value="op"
                          :key="key"                        
                        >
                          {{ op.codigo }} - {{ op.nombre }}
                        </option>
                      </select-->  
                      <input type="date"
                        class="form-control form-control-sm rounded bright mx-2"
                        placeholder="Fecha"
                        v-model="filterTabla.fecha"
                        style="width:200px">  
                      <button class="btn btn-success btn-sm mx-1" type="submit">
                        <i class="fa fa-search"></i>
                      </button>
                      <button
                        class="btn btn-link btn-sm mx-1"
                        type="button"
                        v-on:click="clearFilterData"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                                          
                    </form>
                  </div>
                  <!-------------FIN DE FILTROS---------------->  
                  <!-----------------INICIO DE TABLA------------------------>
                  <div class="element-box" v-if="dataTabla_requerimientos.length==0">
                    <h4 class="text-center">Aún no hay requerimientos para esta tienda</h4>
                  </div>
                  <div class="border border-3 p-1 rounded" v-if="dataTabla_requerimientos.length>0">
                    <div class="">
                      <div class="table rounded table-responsive w-100">
                        
                        <table class="table table-striped table-hover" >
                          <thead>
                            <tr style="background:black; color:white; opacity: 80%;">
                              <td> &nbsp;</td>
                              <td># Req</td>
                              <td>Tienda</td>
                              <td>Fecha</td>
                              <td>Estado</td>
                            </tr>   
                          </thead>
                          <tbody>
                            <template v-for="(t,index) in dataTabla_requerimientos" >
                              <tr @click = "expandClicked(index, t.numero)">                         
                                <td >                         
                                  <i :class= "expandedRow == index ? 'os-icon os-icon-arrow-up4' : 'os-icon os-icon-arrow-down4'"></i>
                                </td>
                                <td>{{ t.numero }}</td>
                                <td>{{ t.nombre_tienda}}</td>
                                <td>{{ t.fecha_creacion}}</td>
                                <td> Cerrado </td>
                              </tr>
                              <tr v-if="expandedRow === index">
                                <td colspan="5">
                                  <div class="p-2">
                                    <div class="border border-3 border-success pt-1">
                                      <h6 class="text-center ">  <b>{{ t.numero }} -- {{ t.nombre_tienda }} </b></h6>                            
                                    </div>
                                    <table class="table table-striped table-sm w-100 rounded table-condensed-custom mt-1" >
                                      <thead class="py-2 bg-success text-white">
                                          <tr >
                                            <th>SKU</th>
                                            <th>Producto</th>
                                            <th>U. Medida</th>
                                            <th>Cantidad</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="elem in productos_del_requerimiento" :key="elem.sku">
                                            <td><b>{{ elem.producto_id }}</b></td>
                                            <td><b>{{ elem.nombre_producto }}</b></td>
                                            <td><b>{{ elem.nombre_unidad }}</b></td>
                                            <td><b>{{ elem.cantidad }}</b></td>
                                          </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>                
                            </template>
                          </tbody>
                        </table>                
                      </div>          
                    </div>   
                    <!-----------------------FIN DE TABLA-------------------------------->
                  <div class="element-wrapper pt-3 mb-0" style="height:30px">
                    <PaginationComponent
                      :currentPage="currentPage"
                      :data="dataTabla"
                      @pagechanged="onPageChange"                
                    />          
                  </div>
              </div>             
          </div>
          <!-------------FIN DE MOSTRAR REQUERIMIENTOS DE TRASLADOS-->
          <div class="row col-12">
            <div class="col-sm-4">
              <ProductoSelectComponentV2 titulo="hide" :current="filter" />
            </div>
            <div class="col-sm-4">
              <SubCategoriaSelectComponent title="hide" :current="filter" />
            </div>
            <div class="col-sm-4">
              <CategoriaSelectComponent title="hide" :current="filter" />
            </div>
          </div>
          <div class="row col-12">
            <div class="col-sm-4">
              <input
                type="text"
                placeholder="Número o barra req"
                class="form-control form-control-sm"
                v-model="filter.numero"
                @change="refreshRequisicionesPendientes()"
              />
              <br />
            </div>
            <div class="col-sm-4">
              <select
                class="form-control form-control-sm"
                v-model="filter.abc"
              >
                <option :value="null">categoría abc</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
              </select>
              <br />
            </div>
            <div class="col-sm-4">
              <ProveedoresSelectComponent titulo="hide" :current="filter" />
            </div>
          </div>
          <div class="col-12 row">
            <div class="col-4">
              <button
                @click="refreshRequisicionesPendientes()"
                class="btn btn-outline-info btn-block"
              >
                <i class="fas fa-search"></i> Buscar
              </button>
            </div>
            <div class="col-4">
              <button @click="resetFilters()" class="btn btn-outline-dark btn-block">
                <i class="fas fa-sync"></i> Reset
              </button>
            </div>
            <div class="col-4">
              <button
                :disabled="!reqs_list[0]"
                @click="agregarTodoDetalle(reqs_list)"
                class="btn btn-outline-success btn-block"
              >
                Agg Todo
              </button>
            </div>
          </div>
          <br/>      
          <div
            style="overflow-y: scroll; max-height: 60vh"
            class="modal-body invoice-table"
          >
            <table class="table table-striped table-lightborder">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th class="text-right">Cant. abierta</th>
                  <th class="text-right">Exist. origen</th>
                  <th class="text-right">Exist. destino</th>
                  <th class="text-center">Fecha</th>
                  <th class="text-center">#</th>
                  <th class="text-center">Tipo Req</th>
                  <th class="text-center">Usuario</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="project-box" v-for="det in reqs_list" :key="det.id">
                  <td class="font-weight-bold">
                    {{ det.producto_id }}
                    <br />
                    <small>{{ det.nombre_producto }}</small>
                  </td>
                  <td class="text-right">{{ det.cantidad_abierta }}</td>
                  <td class="text-right">{{ det.existencia_cedis }}</td>
                  <td class="text-right">{{ det.existencia }}</td>
                  <td class="text-center">
                    {{ det.fecha_creacion | moment("DD/MM/YYYY") }}
                  </td>
                  <td class="text-right">{{ det.numero }}</td>
                  <td class="text-center">{{ det.tipo }}</td>
                  <td class="text-right">{{ det.username }}</td>
                  <td class="text-right">
                    <button
                      @click="AgregarLineaSolicitud(det.id)"
                      class="btn btn-sm btn-info"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DynamicService from "../../../services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import PaginationComponent from "@/components/utils/PaginationComponent";
import { mapGetters } from "vuex";

export default {
  components: {
    ProductoSelectComponentV2,
    SubCategoriaSelectComponent,
    TiendaSelectComponent,
    CategoriaSelectComponent,
    ProveedoresSelectComponent,
    PaginationComponent,
  },
  props: {
    reqs_pendientes: {
      type: Array,
      required: true,
    },
    tarea: {
      type: Object,
      required: true,
    },
    tienda_destino:{
    type: Object,
    required:true,
  }
  },
  watch: {
    reqs_pendientes: function () {
      this.reqs_list = this.reqs_pendientes;
    },

  },
  data() {
    return {
      tipo_filtro: "scaner",
      current: {},
      currentDetalle: {},
      filter: { abc: null },
      reqs_list: [],
      params: {},
      dataTabla:"",
      productos_del_requerimiento: [],
      estado:0,
      expandedRow: null ,    
      currentPage: 1, 
      dataTabla_requerimientos:[],
      filterTabla: {
        tienda_destino: "",
        fecha:""
      },
      tiendas:[]
      
    };
  },
  computed:{   
  },
  mounted(){  
    this.requerimientosTraslados({
      page: this.currentPage,  
      page_size: 10,
      tienda_destino: this.tienda_destino.codigo
    }); 
    this.llenar_tiendas()    
    
  },
  methods: {
    cambiarTipo() {
      let self = this;
      if (self.tipo_filtro == "scaner") {
        self.tipo_filtro = "numero";
      } else {
        self.tipo_filtro = "scaner";
      }
    },
    agregarTodoDetalle(det) {
      let self = this;
      DynamicService.postAction(
        "wms",
        "tareas",
        self.tarea.id,
        "agregar_lista_detalle_tarea_manual",
        det
      )
        .then((response) => {
          this.$emit("refreshCurrent");
          Notifications.toast.success(
            "Agregar lista detalle solicitud",
            "Realizado Exitosamente"
          );
          $("#ModalAggDetalleSolicitud").modal("hide");
          self.resetFilters();
          self.refreshRequisicionesPendientes();
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.subcategoria_no_asignada) {
            let msg = error.response.data.subcategoria_no_asignada;
            Notifications.alert.confirm(
              "Advertencia de Subcategoría",
              msg,
              "Continuar",
              function () {
                let forceDet = det.map(item => ({
                  id: item.id,
                  ignorar_advertencia: true
                }));
                DynamicService.postAction(
                  "wms",
                  "tareas",
                  self.tarea.id,
                  "agregar_lista_detalle_tarea_manual",
                  forceDet
                ).then((response) => {
                  self.$emit("refreshCurrent");
                  Notifications.toast.success(
                    "Agregar lista detalle solicitud",
                    "Realizado Exitosamente"
                  );
                  $("#ModalAggDetalleSolicitud").modal("hide");
                  self.resetFilters();
                  self.refreshRequisicionesPendientes();
                }).catch((errorForce) => {
                  Notifications.alert.error(
                    "Agregar lista detalle solicitud",
                    errorForce.response && errorForce.response.data && errorForce.response.data.detail ? errorForce.response.data.detail : "Error al agregar"
                  );
                });
              }
            );
          } else {
            Notifications.alert.error(
              "Agregar lista detalle solicitud",
              error.response && error.response.data && error.response.data.detail ? error.response.data.detail : "Error al agregar"
            );
          }
        });
    },
    resetFilters() {
      let self = this;
      self.filter.producto = null;
      self.filter.subcategoria = null;
      self.filter.categoria = null;
      self.filter.numero = null;
      self.filter.abc = null;
      self.filter.proveedor = null;
      self.params = {};
      self.reqs_list = self.reqs_pendientes;
    },
    cerrarModal() {
      let self = this;
      self.resetFilters();
      $("#ModalAggXReq").modal("hide");
      $("#ModalAggDetalleSolicitud").modal("hide");
    },
    refreshRequisicionesPendientes() {      
      let self = this;
      let params = {};
      if (self.filter.numero) {
        params.numero = self.filter.numero;
      }
      if (self.tarea.tienda_pedir) {
        params.tienda_origen = self.tarea.tienda_pedir;
      }
      if (self.filter.abc) {
        params.abc = self.filter.abc;
      }
      if (self.filter.proveedor && self.filter.proveedor.codigo) {
        params.proveedor = self.filter.proveedor.codigo;
      }
      if (self.tarea.tienda_destino) {
        params.tienda_destino = self.tarea.tienda_destino;
      }
      if (self.filter.producto) {
        params.producto = self.filter.producto.sku;
      }
      if (self.filter.subcategoria) {
        params.subcategoria = self.filter.subcategoria.codigo;
      }
      if (self.filter.categoria) {
        params.categoria = self.filter.categoria.codigo;
      }
      console.log(params);
      DynamicService.getActionList(
        "wms",
        "tareas",
        "obtener_reqs_para_tarea_manual",
        params
      ).then((response) => {        
        if (response.data == null) {
          self.reqs_list = "";           
        } else {
          self.reqs_list = response.data;
          self.params = {};          
        }      
      });
    },
    AgregarLineaSolicitud(id) {      
      let self = this;
      DynamicService.postAction(
        "wms",
        "tareas", 
        self.tarea.id, 
        "agregar_linea_tarea_manual", 
        {
          id: id,
        }
      )
        .then((response) => {       
          this.$emit("refreshCurrent");
          Notifications.toast.success(
            "Agregar linea solicitud",
            "Realizado Exitosamente"
          );
          self.refreshRequisicionesPendientes();
        })
        .catch((error) => {          
          if (error.response && error.response.data && error.response.data.subcategoria_no_asignada) {
            let msg = error.response.data.subcategoria_no_asignada;
            Notifications.alert.confirm(
              "Advertencia de Subcategoría",
              msg,
              "Continuar",
              function () {
                DynamicService.postAction(
                  "wms",
                  "tareas",
                  self.tarea.id,
                  "agregar_linea_tarea_manual",
                  {
                    id: id,
                    ignorar_advertencia: true,
                  }
                ).then((response) => {
                  self.$emit("refreshCurrent");
                  Notifications.toast.success(
                    "Agregar linea solicitud",
                    "Realizado Exitosamente"
                  );
                  self.refreshRequisicionesPendientes();
                }).catch((errorForce) => {
                  Notifications.alert.error(
                    "Agregar linea solicitud",
                    errorForce.response && errorForce.response.data && errorForce.response.data.detail ? errorForce.response.data.detail : "Error al agregar"
                  );
                });
              }
            );
          } else {
            Notifications.alert.error(
              "Agregar linea solicitud",
              error.response && error.response.data && error.response.data.detail ? error.response.data.detail : "Error al agregar"
            );
          }
        });
    },
    requerimientosTraslados(params){
      let self = this;                
      DynamicService.getActionList("inv","req_traslado", "req_traslados_cerrados", params)         
      .then((response)=>{        
        self.dataTabla = response.data;      
        self.dataTabla_requerimientos = response.data.results  
        self.formatearDatos();      
      })
    },
    formatearFecha(fecha) {
      let fechaFormateada="";    
      let partes=fecha.split('T')[0]
      let partes_solo_fecha = partes.split('-')
      fechaFormateada = partes_solo_fecha[2] + "/" + partes_solo_fecha[1] + "/" + partes_solo_fecha[0]
      return fechaFormateada
    },

    formatearDatos(){
      let self= this;
      self.dataTabla_requerimientos.forEach(elem => {
        let fecha_formateada = self.formatearFecha(elem.fecha_creacion)
        elem.fecha_creacion = fecha_formateada
      })      
    },
    buscarRequerimiento(numero){
      let self = this;   
      if(numero != 0){
        let params={numero:numero}
        DynamicService.getActionList("inv","req_traslado","req_traslados_cerrados_info",params)
        .then((response)=>{      
          self.productos_del_requerimiento = response.data      
        }) 
      }   
    },
    expandClicked(index, num_requerimiento) {
      //controla el estado expandido o colapsado de la fila   
      let self=this;
      if(self.expandedRow=== index){
        self.expandedRow = null;
      }else{
        self.expandedRow = index;
        self.buscarRequerimiento(num_requerimiento);
      }
    }, 
    onPageChange(page) {
      this.currentPage = page;
      this.expandClicked(null,0)
      this.requerimientosTraslados({
        page: this.currentPage,   
        page_size: 10,
        tienda_destino: this.tienda_destino.codigo,
        numero_requerimiento: this.filterTabla.numero_requerimiento,       
        tienda_destino:this.tienda_destino.codigo,  
        fecha: this.filterTabla.fecha
      });
    },

    filterDataSubmit(e) {      
       this.filterData();
      e.preventDefault();
    },

    clearFilterData() {
      this.filterTabla.numero_requerimiento = ""          
      this.filterTabla.fecha = ""     
      this.requerimientosTraslados({
        page: 1,
        page_size:10,
        tienda_destino: this.tienda_destino.codigo,          
      });
      this.onPageChange(1)
    }, 
    filterData() {
      let self = this     
      this.expandClicked(null,0)   
      this.requerimientosTraslados({
        page: 1, 
        page_size: 10,      
        numero_requerimiento: this.filterTabla.numero_requerimiento,
        //tienda_destino: this.filterTabla.tienda_destino.codigo,  
        tienda_destino: this.tienda_destino.codigo,  
        fecha:this.filterTabla.fecha    
      });
    },
    llenar_tiendas() {
      let self = this;      
      DynamicService.fetch("cat", "tiendas", {quitar_paginacion:true})
       .then((response) => {
          self.tiendas = response.data
          self.tiendas.splice(0,1)
          self.tiendas.splice(10,1)        
        })
       .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>
<style scoped>
  .table-condensed-custom td,
  .table-condensed-custom th {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
    line-height: 1.2 !important;
    font-size:0.800rem !important;
  }

  .invoice-table{
    border:none 0px !important;
  }
</style>